<div class="container">
  <mat-card>
    <form [formGroup]="userForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div #userFormRef class="layout-row-wrap layout-lt-md-column gap-2percent">
          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Username' | translate }}</mat-label>
            <input matInput required formControlName="username" />
            @if (userForm.controls.username.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Username' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Email' | translate }}</mat-label>
            <input matInput [required]="userForm.controls.sendPasswordToEmail.value" formControlName="email" />
            @if (userForm.controls.email.hasError('email')) {
              <mat-error>
                {{ 'labels.inputs.Email' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.invalid' | translate }}</strong>
              </mat-error>
            }
            @if (userForm.controls.email.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Email' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.First Name' | translate }}</mat-label>
            <input matInput required formControlName="firstname" />
            @if (userForm.controls.firstname.hasError('pattern')) {
              <mat-error>
                {{ 'labels.inputs.First Name' | translate }}
                <strong>{{ 'labels.commons.cannot begin with a special character or number' | translate }}</strong>
              </mat-error>
            }
            @if (userForm.controls.firstname.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.First Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Last Name' | translate }}</mat-label>
            <input matInput required formControlName="lastname" />
            @if (userForm.controls.lastname.hasError('pattern')) {
              <mat-error>
                {{ 'labels.inputs.Last Name' | translate }}
                <strong>{{ 'labels.commons.cannot begin with a special character or number' | translate }}</strong>
              </mat-error>
            }
            @if (userForm.controls.lastname.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Last Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <div class="password-never-expires-wrapper flex-48">
            <mat-checkbox labelPosition="before" formControlName="passwordNeverExpires">
              {{ 'labels.inputs.Password never expires' | translate }}
            </mat-checkbox>
          </div>

          <div class="send-password-to-email-wrapper flex-48">
            <mat-checkbox labelPosition="before" formControlName="sendPasswordToEmail">
              {{ 'labels.inputs.Send password to email address' | translate }}
            </mat-checkbox>
          </div>

          @if (!userForm.controls.sendPasswordToEmail.value) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Password' | translate }}</mat-label>
              <input matInput required type="password" formControlName="password" />
              @if (userForm.controls.password.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Password' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
              @if (userForm.controls.password.hasError('minlength')) {
                <mat-error>
                  {{ 'labels.commons.Password should be at least' | translate }}
                  <strong>{{ 'labels.commons.12 characters long' | translate }}</strong>
                </mat-error>
              }
              @if (userForm.controls.password.hasError('maxlength')) {
                <mat-error>
                  {{ 'labels.commons.Password should not be more than' | translate }}
                  <strong>{{ 'labels.commons.50 characters long' | translate }}</strong>
                </mat-error>
              }
              @if (
                userForm.controls.password.hasError('pattern') &&
                !(userForm.controls.password.hasError('minlength') || userForm.controls.password.hasError('maxlength'))
              ) {
                <mat-error>
                  {{ 'labels.commons.Password should include a' | translate }}
                  <strong>{{ 'labels.commons.numeral' | translate }}</strong> {{ 'labels.commons.and at' | translate }}
                  <strong>{{ 'labels.commons.least one uppercase' | translate }}</strong> ,<strong>{{
                    'labels.commons.lowercase and special character' | translate
                  }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          @if (!userForm.controls.sendPasswordToEmail.value) {
            <mat-form-field class="flex-48">
              <mat-label>{{ 'labels.inputs.Repeat Password' | translate }}</mat-label>
              <input matInput required type="password" formControlName="repeatPassword" />
              @if (userForm.controls.repeatPassword.hasError('required')) {
                <mat-error>
                  {{ 'labels.inputs.Password' | translate }} {{ 'labels.commons.is' | translate }}
                  <strong>{{ 'labels.commons.required' | translate }}</strong>
                </mat-error>
              }
            </mat-form-field>
          }

          @if (
            userForm.errors?.passwordsDoNotMatch &&
            !userForm.controls.password.hasError('required') &&
            !userForm.controls.repeatPassword.hasError('required')
          ) {
            <p class="flex-98 reset-password-error">
              {{ 'labels.inputs.Passwords' | translate }}
              <strong>{{ 'labels.commons.do not match' | translate }}</strong>
            </p>
          }

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
            <mat-select required formControlName="officeId">
              @for (office of officesData; track office) {
                <mat-option [value]="office.id">
                  {{ office.name }}
                </mat-option>
              }
            </mat-select>
            @if (userForm.controls.officeId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Office' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Staff' | translate }}</mat-label>
            <mat-select formControlName="staffId">
              @for (staff of staffData; track staff) {
                <mat-option [value]="staff.id">
                  {{ staff.displayName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Roles' | translate }}</mat-label>
            <mat-select required formControlName="roles" multiple>
              @for (role of rolesData; track role) {
                <mat-option [value]="role.id">
                  {{ role.name }}
                </mat-option>
              }
            </mat-select>
            @if (userForm.controls.roles.hasError('required')) {
              <mat-error>
                {{ 'labels.commons.At least one role' | translate }}
                <strong>{{ 'labels.commons.must be selected' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!userForm.valid">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>

<ng-template #templateUserFormRef let-popover="popover">
  <h2>{{ 'labels.heading.Create User' | translate }}</h2>
  <p class="mw400">
    {{ 'labels.text.Filling Details' | translate }}:
    <a href="https://LOSforge.jira.com/wiki/spaces/docs/pages/67141740/Users" target="_blank">{{
      'labels.inputs.Users' | translate
    }}</a>
  </p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close()">
      {{ 'labels.buttons.Create User' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStep()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStep()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
